import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import apiService from '../../services/apiServices';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Moment from 'react-moment';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link, useParams } from 'react-router-dom';
import SelectController from '../../controllers/SelectController';
import InputController from '../../controllers/InputController';

const MonthSalariesList = (props) => {
    const { t } = useTranslation();
    let { month, year } = useParams();
    const [salaries, setSalaries] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [workers, setWorkers] = useState([]);
    const [months, setMonths] = useState([]);
    const {
      register,
      control,
      formState: { errors },
    } = useForm();

    const getYear = (date) => {
      return new Date(date).getFullYear()
    }

    const getSalaries = useCallback(() => {
        apiService()
            .get('salaries').then((response) => {
                if (response.success) {
                    let products = response.data;
                    products = products.filter(p => p.Month === Number(month) && getYear(p.SalaryDate) === Number(year))
                    setSalaries(countItems(products));
                } else {
                    //alert('Error:' + response.errorMessage);
                }
            });
    }, [month, year]);

    const getWorkers = useCallback(() => {
      apiService().get('selectworker')
        .then((response) => {
            if (response.success) {
              setWorkers(response.data);
            } else {
              alert('Error:' + response.errorMessage);
            }
          });
    }, []);

    const getMonths = useCallback(() => {
      apiService().get('months')
        .then((response) => {
              if (response.success) {
                setMonths(response.data);
                console.log('mooooo', response)
              } else {
                alert('Error:' + response.errorMessage);
              }
            });
    }, []);

    const onRowClick = (no) => {
      let rowItem = [...salaries]
      rowItem.forEach(i => i.editMode = false);
      rowItem[no-1].editMode = !rowItem[no-1].editMode;
      setSalaries(rowItem);
    }

    const addRow = () => {
      // Build a fresh blank row each time — reusing the shared `obj` constant
      // pushed the same mutated reference for every click (duplicate dummy rows).
      const newItem = {
        Advances: 0,
        FirstName: "",
        Id: 0,
        LastName: "",
        Month: Number(month),
        Salary: 0,
        SalaryDate: new Date(Number(year), Number(month) - 1, 1).toISOString(),
        no: Math.max(...salaries.map(o => o.no), 0) + 1,
      }
      const newState = [...salaries, newItem];
      setSalaries(countItems(newState))
    }

    const deleteRow = (rowId) => {
      let arrayCopy = [...salaries]
      let item = arrayCopy.find(i => i.no === rowId);
      item.status = -1; //status.deleted;
      setSalaries(countItems(arrayCopy))
    }

    const countItems = (arr) => {
      let count = 1;
      arr.forEach(i => { i.no = count; count++ });
      return arr;
    }

    const cimi = (e) => {
      console.log(e)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(()=> {
        getSalaries();
        getWorkers();
        getMonths();
    }, [getMonths, getSalaries, getWorkers, month, year])
    return (
        <div>
        <TopActions newHref="/salarieslist/addsalary" saveHref="/dashboard/" />
        <Typography variant="h6" gutterBottom>
              {t('salaries.salaryListForMonth')}: {months.find(m => m.id === Number(month))?.name}, {year}
        </Typography>
        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table stickyHeader size="small" aria-label="salary table">
          <TableHead>
            <TableRow>
              <TableCell>Edit</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Nr</TableCell>
              <TableCell>{t('worker.table.employee')}</TableCell>
              <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{t('common.month')}</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{t('common.date')}</TableCell>
              <TableCell>{t('salaries.salary')}</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{t('salaries.advance')}</TableCell>
              <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{t('salaries.extraHours')}</TableCell>
              <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>{t('salaries.extraHoursPay')}</TableCell>
              <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{t('salaries.bonus')}</TableCell>
              <TableCell>{t('salaries.total')}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {salaries
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((w, index) => ( w.status !== -1 &&
                <TableRow key={w.Id+index}>
                  <TableCell>
                    <ButtonGroup size="small">
                      <Link to={`/salarieslist/editsalary/${w.Id}`}>
                        <Button>
                          <EditIcon />
                        </Button>
                      </Link>
                      {/* <Button onClick={() => openModal(w.Id)}>
                        <DeleteIcon />
                      </Button> */}
                    </ButtonGroup>
                  </TableCell>
                  <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{index + 1}</TableCell>
                  {w.editMode ? 
                    <TableCell><SelectController onChangeProp={(e) => cimi(e)} error={errors.WorkerId} control={control} options={workers} name="WorkerId" register={{ ...register('WorkerId') }}/></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>{w.FirstName}</TableCell>
                  }
                  {w.editMode ?
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}><SelectController error={errors.Month} control={control} options={months} name="Month" register={{ ...register('Month') }} /></TableCell>
                    :
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }} onClick={function () { onRowClick(w.no) }}>{months.find(m => m.id === w.Month)?.name}</TableCell>
                  }     
                  {
                    w.editMode ? 
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                      <InputController error={errors.SalaryDate} control={control} type="date" register={{ ...register('SalaryDate') }} />
                    </TableCell>
                    :
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }} onClick={function () { onRowClick(w.no) }}>
                      <Moment format="DD/MM/YYYY">{w.SalaryDate}</Moment>
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell><InputController error={errors.Salary} control={control} symbol="€" register={{ ...register('Salary') }} /></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(w.Salary)}
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}><InputController error={errors.Advances} control={control} symbol="€" register={{ ...register('Advances') }} /></TableCell>
                    :
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }} onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'EUR' }).format(w.Advances)}
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}><InputController error={errors.ExtraHours} control={control} register={{ ...register('ExtraHours') }} /></TableCell>
                    :
                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }} onClick={function () { onRowClick(w.no) }}>{w.ExtraHours}</TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}><InputController error={errors.HourSalary} control={control} symbol="€" register={{ ...register('HourSalary') }} /></TableCell>
                    :
                    <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }} onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'EUR' }).format(w.HourSalary)}
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}><InputController error={errors.Bonus} control={control} symbol="€" register={{ ...register('Bonus') }} /></TableCell>
                    :
                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }} onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'EUR' }).format(w.Bonus)}
                    </TableCell>
                  }
                  <TableCell></TableCell>
                  <TableCell>
                    <ButtonGroup size="small">
                        <Button onClick={() => deleteRow(w.no)}>
                          <DeleteIcon />
                        </Button>
                        {salaries.length === index+1 && 
                          <Button onClick={() => addRow()}>
                            <AddIcon />
                          </Button> 
                        }
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={salaries.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
        </div>
    )
}

export default MonthSalariesList
